import { all, call, fork, put, select, takeEvery } from "@redux-saga/core/effects";
import { ON_ADD_PAYMENT } from "../../constants/ActionTypes";
import { postData } from "../../util/DynamicApi";
import { AddPaymentSuccess } from "../actions/Payment";

export const getToken = ({ auth }) => auth.token;
const addPaymentRequest = async (token, data) =>
    await postData(token, "Payment/Payment", data.payload)
        .then((payment) => {
            return payment;
        })
        .catch((error) => {
            return error.response.data;;
        });
function* doAddPayment(payload) {
    try {
        let data={payload};
        let token = yield select(getToken);
        const payment = yield call(addPaymentRequest, token,data.payload );
        yield put(AddPaymentSuccess(payment.data));
    } catch (error) {
    }
}

export function* addPayment() {
    yield takeEvery(ON_ADD_PAYMENT, doAddPayment);
}
export default function* rootSaga() {
    yield all([
        fork(addPayment)]);
}
